import { z } from 'zod';

export const CreateChapterSchema = z.object({
  title: z.string().min(1).max(300),
  subtitle: z.string().trim().max(50).optional(),
  index: z.number().int().min(1),
  isDemo: z.boolean().default(false),
});

export type CreateChapterDto = z.infer<typeof CreateChapterSchema>;

export const UpdateChapterSchema = CreateChapterSchema.partial().extend({
  visibility: z.enum(['draft', 'published', 'hidden']).optional(),
});

export type UpdateChapterDto = z.infer<typeof UpdateChapterSchema>;

export const CreateBlockSchema = z.object({
  index: z.number().int().min(1),
  type: z.enum(['text', 'image', 'video', 'quote', 'divider']),
  payload: z.record(z.unknown()),
});

export type CreateBlockDto = z.infer<typeof CreateBlockSchema>;
